module.exports = __webpack_public_path__ + "static/media/Payments.9c9bde7c.svg";